import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import HelpIcon from '@mui/icons-material/Help';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { Outlet, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import RoleCheck from "../Authorisation/RoleCheck";
import Tooltip from "@mui/material/Tooltip";
import { AuthContext } from "../Authorisation/AuthContext";
import { APIContext } from "../Contexts/APIContext";
import TermsAndConditionsDialog from "../Authorisation/TermsAndConditionsDialog";

const fullWidth = 220;
const collapsedWidth = 60;

// Navigation items array to avoid repetition
const navItems = [
    { label: "Home", path: "/home", icon: <HomeIcon /> },
    { divider: true },
    { label: "Trip Rate", path: "/triprate", icon: <QueryStatsIcon /> },
    { label: "Site List", path: "/sitelist", icon: <FormatListBulletedIcon /> },
    { label: "Time Series Analysis", path: "/timeseriesanalysis", icon: <AnalyticsIcon /> },
    { divider: true },
    { label: "Library", path: "/library", icon: <AutoStoriesIcon /> },
    { label: "Help", path: "/help", icon: <HelpIcon /> },
    { label: "Saved Reports", path: "/savedreports", icon: <FolderSpecialIcon /> },
    { label: "Saved Sessions", path: "/savedsessions", icon: <BookmarksIcon /> },
   /* { label: "Legacy Files", path: "/legacyfiles", icon: <FolderZipIcon /> },*/
    { divider: true },
    { label: "My Organisation", path: "/myorganisation", icon: <LocationCityIcon />, role: ["Manager"] },
    { label: "My Account", path: "/myaccount", icon: <ManageAccountsIcon /> },
    { label: "TRICS Admin", path: "/admin/", icon: <DashboardIcon />, role: ["Admin"] },
    { label: "Superadmin", path: "/admin/superadmin", icon: <AdminPanelSettingsIcon />, role: ["SuperAdmin"] },
];

export default function SideNav() {
    const location = useLocation();
    const navigate = useNavigate();
    const { userDetails } = useContext(AuthContext);
    const { getUserSetting, setUserSetting } = useContext(APIContext);
    const [collapsed, setCollapsed] = useState(true);
    const [showText, setShowText] = useState(true);

    useEffect(() => {
        getUserSetting("Side Nav Collapsed State", (value) => {
            if (value === "Open") {
                setCollapsed(false);
            }
            else if (value === "Closed") {
                setCollapsed(true);
            }
        });
    }, []);

    const collapseToggle = () => {
        setShowText(false)
        let value = "";
        if (collapsed) {
            value = "Open"
        }
        else {
            value = "Closed"
        }
        setUserSetting("Side Nav Collapsed State", value)
        setCollapsed(!collapsed)

    }

    return (
        <Box display="flex" height="100%">
            <TermsAndConditionsDialog />
            <Box
                sx={{
                    width: collapsed ? collapsedWidth : fullWidth,
                    overflow: "hidden",
                    height: "100%",
                    backgroundColor: "white",
                    transition: "width 0.3s ease"
                }}
                onAnimationEnd={() => setShowText(true)}
            >
                {
                    userDetails?.offline ? <Box />
                        :
                        <Stack
                            alignItems="stretch"
                            justifyContent="space-between"
                            height="100%"
                            overflow="hidden"
                        >
                            <List sx={{ overflowY: "auto", overflowX: "hidden" }}>
                                {navItems.map((item, index) =>
                                (item.divider ? (
                                    <Divider key={index} />
                                ) : (
                                    (!collapsed && showText) ?
                                        <RoleCheck key={index} requriedRole={item.role ?? []}>
                                            <ListItemButton key={item.path} onClick={() => navigate(item.path!)} selected={location.pathname == item.path}>
                                                <ListItemIcon sx={{ marginY: 0.5 }}>{item.icon}</ListItemIcon>
                                                <ListItemText primary={item.label} />
                                            </ListItemButton>
                                        </RoleCheck>
                                        :
                                        <RoleCheck key={index} requriedRole={item.role ?? []}>
                                            <Tooltip key={index} title={item.label} placement="right">
                                                <ListItemButton key={item.path} onClick={() => navigate(item.path!)} selected={location.pathname == item.path}>
                                                    <ListItemIcon sx={{ marginY: 0.5 }}>{item.icon}</ListItemIcon>
                                                </ListItemButton>
                                            </Tooltip>
                                        </RoleCheck>
                                )
                                )
                                )}
                            </List>
                            <Stack
                                alignItems="flex-end"
                                padding={1.2}
                            >
                                <Box
                                    padding={1}
                                    component="img"
                                    src="/trics_lowop.png"
                                    width="100%"
                                    sx={{
                                        transition: collapsed ? 'opacity 0.1s' : 'opacity 0.5s ease',
                                        transitionDelay: collapsed ? '0s' : '0.3s',
                                        opacity: collapsed ? '0' : '1',
                                    }} />

                                <IconButton onClick={collapseToggle}>
                                    {collapsed ? <MenuIcon /> : <ChevronLeftIcon />}
                                </IconButton>
                            </Stack>
                        </Stack>
                }
            </Box>
            {/* Main Content */}
            <Box flex={1} overflow="auto" height="100%" padding={location.pathname.split("/")[1] == 'triprate' ? "" : "8px"}>
                <Outlet />
            </Box>
        </Box>
    );
}
